// import React, { useState, useEffect } from 'react';
// import './PeriodicalManagement.css';
// import * as Constants from '../../Constant/constant';

// function PeriodicalManagement() {
//     const [showPeriodicalManagement, setShowPeriodicalManagement] = useState(true);
//     const [title, setTitle] = useState('');
//     const [periodicity, setPeriodicity] = useState('');
//     const [publisher, setPublisher] = useState('');
//     const [perVolume, setPerVolume] = useState('');
//     const [subscription, setSubscription] = useState('');
//     const [orderNo, setOrderNo] = useState('');
//     const [amount, setAmount] = useState('');
//     const [source, setSource] = useState('');
//     const [billNo, setBillNo] = useState('');
//     const [paidOn, setPaidOn] = useState('');
//     const [expiryDate, setExpiryDate] = useState('');
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');
//     const [volume, setVolume] = useState('');
//     const [number, setNumber] = useState('');
//     const [remarks, setRemarks] = useState('');
//     const [searchQueryPeriodical, setSearchQueryPeriodical] = useState('');
//     const [periodicalList, setPeriodicalList] = useState([]);
//     const [loadingPeriodicalList, setLoadingPeriodicalList] = useState(false);
//     const [errorPeriodicalList, setErrorPeriodicalList] = useState(null);

//     useEffect(() => {
//         const fetchPeriodicalList = async () => {
//             setLoadingPeriodicalList(true);
//             setErrorPeriodicalList(null);
//             try {
//                 const response = await fetch(Constants.API_PATH +`/periodicals_data`); // Replace with your API endpoint
//                 if (!response.ok) {
//                     throw new Error('Failed to fetch periodical list');
//                 }
//                 const data = await response.json();
//                 setPeriodicalList(data);
//             } catch (error) {
//                 setErrorPeriodicalList(error.message);
//             } finally {
//                 setLoadingPeriodicalList(false);
//             }
//         };

//         fetchPeriodicalList();
//     }, []);

//     const handleAddPeriodical = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await fetch(Constants.API_PATH +`/periodicals`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     title,
//                     periodicity,
//                     publisher,
//                     perVolume,
//                     subscription,
//                     orderNo,
//                     amount,
//                     source,
//                     billNo,
//                     paidOn,
//                     expiryDate,
//                     fromDate,
//                     toDate,
//                     volume,
//                     number,
//                     remarks,
//                 }),
//             });

//             if (!response.ok) {
//                 throw new Error('Failed to add periodical');
//             }

//             // Reset form fields
//             setTitle('');
//             setPeriodicity('');
//             setPublisher('');
//             setPerVolume('');
//             setSubscription('');
//             setOrderNo('');
//             setAmount('');
//             setSource('');
//             setBillNo('');
//             setPaidOn('');
//             setExpiryDate('');
//             setFromDate('');
//             setToDate('');
//             setVolume('');
//             setNumber('');
//             setRemarks('');
//             // Fetch updated periodical list
//             setPeriodicalList();
//         } catch (error) {
//             setErrorPeriodicalList(error.message);
//         }
//     };

//     const handleSearchChangePeriodical = (e) => {
//         setSearchQueryPeriodical(e.target.value);
//     };

//     const handleSearchPeriodical = () => {
//         // Logic to filter periodical list based on search query
//         console.log('Searching periodicals for:', searchQueryPeriodical);
//     };

//     const handleExportPeriodicalReport = () => {
//         // Logic to export the periodical report
//         console.log('Exporting periodical report...');
//     };

//     return (
//         showPeriodicalManagement && (
//             <div className="periodical-management-section containernew">
//                 <nav className="breadcrumb">
//                     <a href="#" className="breadcrumb-link">Home</a> /
//                     <a href="#" className="breadcrumb-link">Library Management</a> /
//                     <span className="breadcrumb-current">Periodical Report</span>
//                 </nav>

//                 <h2 className="section-title">Add Periodical Report</h2>
//                 <form onSubmit={handleAddPeriodical} className="periodical-form">
//                     <div className="form-grid">
//                         <div className="form-group">
//                             <label htmlFor="title" className="form-label">Title*</label>
//                             <input type="text" id="title" className="form-input" value={title} onChange={(e) => setTitle(e.target.value)} required />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="periodicity" className="form-label">Periodicity*</label>
//                             <select id="periodicity" className="form-select" value={periodicity} onChange={(e) => setPeriodicity(e.target.value)} required>
//                                 <option value="">Select Periodicity</option>
//                                 <option value="Daily">Daily</option>
//                                 <option value="Weekly">Weekly</option>
//                                 <option value="Monthly">Monthly</option>
//                                 <option value="Yearly">Yearly</option>
//                             </select>
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="publisher" className="form-label">Publisher</label>
//                             <input type="text" id="publisher" className="form-input" value={publisher} onChange={(e) => setPublisher(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="perVolume" className="form-label">Per Volume</label>
//                             <input type="text" id="perVolume" className="form-input" value={perVolume} onChange={(e) => setPerVolume(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="subscription" className="form-label">Subscription</label>
//                             <input type="text" id="subscription" className="form-input" value={subscription} onChange={(e) => setSubscription(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="orderNo" className="form-label">Order No</label>
//                             <input type="text" id="orderNo" className="form-input" value={orderNo} onChange={(e) => setOrderNo(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="amount" className="form-label">Amount</label>
//                             <input type="text" id="amount" className="form-input" value={amount} onChange={(e) => setAmount(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="source" className="form-label">Source</label>
//                             <input type="text" id="source" className="form-input" value={source} onChange={(e) => setSource(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="billNo" className="form-label">Bill No</label>
//                             <input type="text" id="billNo" className="form-input" value={billNo} onChange={(e) => setBillNo(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="paidOn" className="form-label">Paid On</label>
//                             <select id="paidOn" className="form-select" value={paidOn} onChange={(e) => setPaidOn(e.target.value)}>
//                                 <option value="">Select Option</option>
//                                 <option value="Cash">Cash</option>
//                                 <option value="Check">Check</option>
//                                 <option value="Card">Card</option>
//                             </select>
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="expiryDate" className="form-label">Expiry Date</label>
//                             <input type="date" id="expiryDate" className="form-input" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="fromDate" className="form-label">From Date*</label>
//                             <input type="date" id="fromDate" className="form-input" value={fromDate} onChange={(e) => setFromDate(e.target.value)} required />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="toDate" className="form-label">To Date*</label>
//                             <input type="date" id="toDate" className="form-input" value={toDate} onChange={(e) => setToDate(e.target.value)} required />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="volume" className="form-label">Volume</label>
//                             <input type="text" id="volume" className="form-input" value={volume} onChange={(e) => setVolume(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="number" className="form-label">Number</label>
//                             <input type="text" id="number" className="form-input" value={number} onChange={(e) => setNumber(e.target.value)} />
//                         </div>
//                         <div className="form-group">
//                             <label htmlFor="remarks" className="form-label">Remarks</label>
//                             <input type="text" id="remarks" className="form-input" value={remarks} onChange={(e) => setRemarks(e.target.value)} />
//                         </div>
//                     </div>
//                     <button type="submit" className="submit-button">Submit</button>
//                 </form>
//                 <hr />

//                 <div className="list-filters">
//                     <input
//                         type="text"
//                         className="search-input"
//                         placeholder="Title"
//                         value={searchQueryPeriodical}
//                         onChange={handleSearchChangePeriodical}
//                     />
//                     <button className="search-button" onClick={handleSearchPeriodical}>Search</button>
//                     <button className="export-button" onClick={handleExportPeriodicalReport}>Export Periodical Report</button>
//                 </div>

//                 <div className="table-responsive">
//                     {loadingPeriodicalList ? (
//                         <p>Loading periodical list...</p>
//                     ) : errorPeriodicalList ? (
//                         <p>{errorPeriodicalList}</p>
//                     ) : (
//                         <table className="custom-table">
//                             <thead>
//                                 <tr>
//                                     <th>Sr. No.</th>
//                                     <th>Title</th>
//                                     <th>Date</th>
//                                     <th>Month</th>
//                                     <th>Year</th>
//                                     <th>Volume</th>
//                                     <th>Number</th>
//                                     <th>Date Of Receipt</th>
//                                     <th>Remarks</th>
//                                     <th>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {periodicalList.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="10">No data available in table</td>
//                                     </tr>
//                                 ) : (
//                                     periodicalList.map((periodical, index) => (
//                                         <tr key={index}>
//                                             <td>{index + 1}</td>
//                                             <td>{periodical.title}</td>
//                                             <td>{periodical.date}</td>
//                                             <td>{periodical.month}</td>
//                                             <td>{periodical.year}</td>
//                                             <td>{periodical.volume}</td>
//                                             <td>{periodical.number}</td>
//                                             <td>{periodical.dateOfReceipt}</td>
//                                             <td>{periodical.remarks}</td>
//                                             <td><button>Action</button></td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     )}
//                 </div>
//             </div>
//         )
//     );
// }

// export default PeriodicalManagement;

import React, { useState, useEffect } from 'react';
import './PeriodicalManagement.css';
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function PeriodicalManagement() {
  const [modalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [periodicity, setPeriodicity] = useState('');
  const [publisher, setPublisher] = useState('');
  const [perVolume, setPerVolume] = useState('');
  const [subscription, setSubscription] = useState('');
  const [orderNo, setOrderNo] = useState('');
  const [amount, setAmount] = useState('');
  const [source, setSource] = useState('');
  const [billNo, setBillNo] = useState('');
  const [paidOn, setPaidOn] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [volume, setVolume] = useState('');
  const [number, setNumber] = useState('');
  const [remarks, setRemarks] = useState('');
  const [periodicalList, setPeriodicalList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPeriodicalList = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${Constants.API_PATH}/periodicals_data`);
      const data = await res.json();
      setPeriodicalList(data);
    } catch (err) {
      setError('Failed to fetch periodicals');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPeriodicalList();
  }, []);

  const handleAddPeriodical = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${Constants.API_PATH}/periodicals`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title,
          per_volume: perVolume,
          amount,
          paid_on: paidOn,
          expiry_date: expiryDate,
          periodicity,
          subscription,
          source,
          publisher,
          order_no: orderNo,
          bill_no: billNo,
          from_date: fromDate,
          to_date: toDate,
          volume,
          number,
          remarks
        })
      });
      const data = await res.json();
      if (data.message) {
        fetchPeriodicalList();
        setModalOpen(false);
      } else {
        alert(data.error || "Error inserting data");
      }
    } catch (err) {
      alert("Submission failed.");
    }
  };

  return (
    <div className="periodical-management-section containernew">
      <div className="header">
        <h2>Periodical Management</h2>
        <button className="submit-btn" onClick={() => setModalOpen(true)}>+ Add New</button>
      </div>

      {/* Modal Form */}
      {modalOpen && (
        <div className="modal-overlay ">
          <div className="modal-content">
            <h3>Add Periodical</h3>
            <form onSubmit={handleAddPeriodical}>
              <div className="form-grid">
                <input type="text" placeholder="Title*" required value={title} onChange={(e) => setTitle(e.target.value)} />
                <SearchableSelect
                  required
                  value={periodicity}
                  onChange={(e) => setPeriodicity(e.target.value)}
                  options={[
                    { value: 'Daily', label: 'Daily' },
                    { value: 'Weekly', label: 'Weekly' },
                    { value: 'Monthly', label: 'Monthly' },
                    { value: 'Yearly', label: 'Yearly' }
                  ]}
                  placeholder="Select Periodicity"
                />
                <input type="text" placeholder="Publisher" value={publisher} onChange={(e) => setPublisher(e.target.value)} />
                <input type="text" placeholder="Per Volume" value={perVolume} onChange={(e) => setPerVolume(e.target.value)} />
                <input type="text" placeholder="Subscription" value={subscription} onChange={(e) => setSubscription(e.target.value)} />
                <input type="text" placeholder="Order No" value={orderNo} onChange={(e) => setOrderNo(e.target.value)} />
                <input type="number" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} />
                <input type="text" placeholder="Source" value={source} onChange={(e) => setSource(e.target.value)} />
                <input type="text" placeholder="Bill No" value={billNo} onChange={(e) => setBillNo(e.target.value)} />
                <SearchableSelect
                  value={paidOn}
                  onChange={(e) => setPaidOn(e.target.value)}
                  options={[
                    { value: 'Cash', label: 'Cash' },
                    { value: 'Check', label: 'Check' },
                    { value: 'Card', label: 'Card' }
                  ]}
                  placeholder="Paid On"
                />
                <label>Date Fields</label>
                <input type="date" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
                <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                <input type="text" placeholder="Volume" value={volume} onChange={(e) => setVolume(e.target.value)} />
                <input type="text" placeholder="Number" value={number} onChange={(e) => setNumber(e.target.value)} />
                <input type="text" placeholder="Remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} />
              </div>
              <div className="modal-actions">
                <button type="submit" className="submit-btn">Submit</button>
                <button type="button" className="cancel-btn" onClick={() => setModalOpen(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <hr />

      <h3>Periodical List</h3>
      {loading ? <p>Loading...</p> : error ? <p>{error}</p> : (
        <table className="custom-table">
          <thead>
            <tr>
              <th>Sr.</th>
              <th>Title</th>
              <th>Periodicity</th>
              <th>Publisher</th>
              <th>From</th>
              <th>To</th>
              <th>Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {periodicalList.length === 0 ? (
              <tr><td colSpan="8">No Data Found</td></tr>
            ) : periodicalList.map((item, idx) => (
              <tr key={item.id}>
                <td>{idx + 1}</td>
                <td>{item.title}</td>
                <td>{item.periodicity}</td>
                <td>{item.publisher}</td>
                <td>{item.from_date}</td>
                <td>{item.to_date}</td>
                <td>{item.amount}</td>
                <td><button>Edit</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default PeriodicalManagement;
